import { Box, Button, Stack, styled, TextField, Typography } from '@mui/material';
import Link from '@mui/material/Link';
import { ElementType } from 'react';

interface LinkProps {
  component: ElementType;
}

export const FormBox = styled(Stack)`
  width: 100%;
  min-width: 550px;
  max-width: 550px;
  background: ${({ theme }) => theme.palette.background.paper};
  box-shadow: 0px 4px 20px 0px rgba(129, 129, 129, 0.12);
  border-radius: 24px;
  overflow: hidden;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    min-width: unset;
    max-width: 100%;
    border-radius: 16px;
  }
`;

export const FormContent = styled(Stack)`
  padding: 40px;
  gap: 32px;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding: 24px 20px;
    gap: 28px;
  }
`;

export const Title = styled(Typography)`
  text-align: center;
  font-weight: 600;
  font-size: 36px;
  line-height: 42px;
  color: ${({ theme }) => theme.palette.grey[800]};
  margin-bottom: 1rem;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    font-size: 28px;
    line-height: 34px;
  }
`;

export const StyledLink = styled(Link)<LinkProps>`
  color: ${({ theme }) => theme.palette.grey[700]};
  text-decoration: none;
  width: fit-content;

  span {
    color: ${({ theme }) => theme.palette.grey[800]};
    font-weight: 700;
  }
  &:hover {
    span {
      text-decoration: underline;
    }
  }
`;

export const ForgotPasswordLink = styled(Link)`
  color: ${({ theme }) => theme.palette.primary.main};
  font-weight: 500;
  margin-top: 1rem;
  cursor: pointer;
`;

export const GoogleButton = styled(Button)`
  background: ${({ theme }) => theme.palette.common.white};
  color: ${({ theme }) => theme.palette.grey[700]};
  border: 1px solid ${({ theme }) => theme.palette.grey[200]};
  border-radius: 14px;
  font-weight: 500;
  margin-top: 1rem;
  &:hover {
    background: ${({ theme }) => theme.palette.grey[100]};
  }
`;

export const PolicyText = styled(Typography)`
  color: ${({ theme }) => theme.palette.grey[600]};
  span {
    font-weight: 700;
  }
`;

export const PhoneNumberFieldContainer = styled(Box)`
  display: flex;
  align-items: flex-start;
`;

export const PhoneSelect = styled(TextField)<{ size?: 'small' | 'medium' }>`
  width: ${({ size }) => (size === 'small' ? '75px' : '80px')};

  .MuiInputBase-root {
    border-radius: 100px 0 0 100px;
    padding-left: 7px;
    font-size: ${({ size }) => (size === 'small' ? '18px' : '24px')};
    max-height: ${({ size }) => (size === 'small' ? '40px' : '56px')};
    overflow: hidden;
    white-space: nowrap;
    text-overflow: clip;
  }
`;

export const CustomPhoneInput = styled(TextField)`
  flex: 1;
  max-height: 56px;
  .MuiInputBase-root {
    border-radius: 0 100px 100px 0;
  }
`;

export const TabContainer = styled(Box)`
  display: flex;
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey[200]};
`;

export const TabButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active?: boolean }>`
  flex: 1;
  background: transparent;
  color: ${({ active, theme }) => (active ? theme.palette.primary.main : theme.palette.grey[600])};
  font-weight: ${({ active }) => (active ? 600 : 500)};
  text-transform: none;
  padding: 16px 24px;
  border-radius: 0;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    height: 2px;
    background: ${({ active, theme }) => (active ? theme.palette.primary.main : 'transparent')};
  }

  &:hover {
    background: transparent;
    color: ${({ active, theme }) => (active ? theme.palette.primary.main : theme.palette.grey[700])};
  }
`;
